<template>
  <div class="upsell products">

    <div v-if="!$trans('product::product.upsell_products_link')" class="h2">{{ $trans('product::product.upsell_products') }}</div>
    <div v-else class="h2">
      <a :href="$trans('product::product.upsell_products_link')">{{ $trans('product::product.upsell_products') }}</a>
    </div>

    <div class="products bg-white">
      <div class="row" ref="productsPlaceholder">
          <ProductCardWrapped v-for="(product, index) in products" :key="index" :product="product"></ProductCardWrapped>
      </div>
    </div>
  </div>
</template>

<script>
    import ProductCardWrapped from './../../ProductCardWrapped.vue';
    import { slickPrevArrow, slickNextArrow } from '../../../functions';

    export default {
        components: { ProductCardWrapped },

        props: ['products'],

        computed: {
            hasAnyProduct() {
                return this.products.length !== 0;
            },
        },

        mounted() {
            $(this.$refs.productsPlaceholder).slick({
                rows: 0,
                dots: false,
                arrows: true,
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 4,
                rtl: window.Shop.rtl,
                // prevArrow: slickPrevArrow(),
                // nextArrow: slickNextArrow(),
                responsive: [
                    {
                        breakpoint: 1761,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                        },
                    },
                    {
                        breakpoint: 1341,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                        },
                    },
                    {
                        breakpoint: 1081,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 881,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                    {
                        breakpoint: 661,
                        settings: {
                            dots: false,
                            arrows: true,
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                    {
                        breakpoint: 641,
                        settings: {
                            dots: false,
                            arrows: true,
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                ],
            });
        },
    };
</script>
